import { useTranslation } from "react-i18next";
import * as Yup from "yup";
const useRegisterSchema = () => {
  const { t } = useTranslation();
  return Yup.object().shape({
    phoneNumber: Yup.string().required(t("required_phone_number")),
    username: Yup.string().required(t("required_username")),
    privacy: Yup.boolean()
      .oneOf([true], t("privacy_policy_required")) 
      .required(t("required")),
  });
};

export default useRegisterSchema;
